var VERSION = 1771987321499
export  {
	VERSION
} 
